import { CART_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";

interface IAPIreturnProps {
  status: boolean;
  data: IJobCardEligibilityResponseData | null;
}

interface IJobCardEligibilityPet {
  name: string;
  id: string;
  job_card_present: boolean;
}

interface IJobCardEligibilityResponseData {
  eligible: boolean;
  pets: IJobCardEligibilityPet[];
}

AxiosCurlirize(axios, () => {});

export const useJobCardEligibilityAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const [data, setData] = useState<IJobCardEligibilityResponseData | null>(null);

  const execute = useCallback(
    async (cartId: string) => {
      try {
        if (!cartId) {
          return { status: false, data: null };
        }

        setData(null);
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: IAPIreturnProps = await axios
          .get(`${CART_MODULE?.JOB_CARD_ELIGIBILITY?.baseURL}/${cartId}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            const responseData = res?.data?.data ?? res?.data ?? null;
            setData(responseData);
            return { status: true, data: responseData };
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config?.["curlCommand"]);
            captureError(e);
            setData(null);
            return { status: false, data: null };
          });

        return response;
      } catch (_e) {
        setData(null);
        return { status: false, data: null };
      }
    },
    [captureError, configuration.localStorage.ACCESS_TOKEN.key, sendCurl],
  );

  return { data, execute };
};
